var _a, _b, _c;
import { trackEvent } from "@pb/utils/tracking";
import { default as getCookie } from "@pb/utils/getCookie";
import { getTouchpoint } from "@pb/utils/touchpoint";
const getAttribute = (attribute) => { var _a; return ((_a = window.utag_data) === null || _a === void 0 ? void 0 : _a[attribute]) || ''; };
const PROMO_ACTIONS = {
    PROMO_VIEW: 'promoview',
    PROMO_CLICK: 'promo_click',
};
const generalTrackingConstants = {
    page_id: getAttribute('page_id') || '',
    page_type: getAttribute('page_type' || ''),
    category_id: getAttribute('category_id' || ''),
    category_path: getAttribute('category_path') || '',
    region_locale: ((_a = getCookie('HMCORP_locale')) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || '',
    region_market: window && window.getRegionMarket ? window.getRegionMarket().toUpperCase() : '',
    region_currency: ((_b = getCookie('HMCORP_currency')) === null || _b === void 0 ? void 0 : _b.toLocaleUpperCase()) || '',
    session_touchpoint: getTouchpoint(),
    session_login_status: ((_c = document.getElementsByClassName('is-logged-in')) === null || _c === void 0 ? void 0 : _c.length) > 0 ? 'TRUE' : 'FALSE',
};
export const trackingQSP = (activityCode, activityType, promotionCreative) => {
    const trackingData = Object.assign(Object.assign({}, generalTrackingConstants), { promo_action: PROMO_ACTIONS.PROMO_CLICK, promo_id: [activityCode] || [], promo_name: [activityType] || [], promo_creative: [promotionCreative] || [] });
    trackEvent(trackingData, false, false);
};
//# sourceMappingURL=tracking.js.map